import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { lazy, Suspense } from "react";
import Spinner from "./Spinner";

const Gallery = lazy(() =>  import ("./Pages/Gallery"));
const Contact = lazy(() =>  import ("./Pages/Contact"));
const TermsOfService = lazy(() =>  import ("./Pages/TermsOfService"));
const Basket = lazy(() =>  import ("./Pages/Basket"));
const Layout = lazy(() =>  import ("./Layout"));
const MeetCindy = lazy(() =>  import ("./Pages/MeetCindy"));
const Summary = lazy(() => import ("./Pages/Summary"));
// const LandingPage = lazy(() =>  import ("./Pages/LandingPage"));


const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path='/' element={<Layout />}>
          {/* <Route index element={<LandingPage />} /> */}
          <Route 
            path='meet-cindy' 
            element={
            <Suspense fallback={<Spinner/>}>
                <MeetCindy />
            </Suspense>
            } 
          />
          <Route 
            path='gallery/:category' 
            element={
              <Gallery />
            } 
          />
          <Route 
            path='contact' 
            element={
              <Suspense fallback={<Spinner/>}>
                <Contact />
              </Suspense>
            } 
          />
          <Route 
            path='terms-of-service' 
            element={
              <Suspense fallback={<Spinner/>}>
                <TermsOfService />
              </Suspense>
            } 
          />
          <Route 
            path='basket' 
            element={
              // <Suspense fallback={<Spinner/>}>
                <Basket />
              // </Suspense>
            } 
          />
          <Route
            path='summary'
            element={
              <Suspense fallback={<Spinner/>}>
                <Summary />
              </Suspense>
            }
          />
        </Route>
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;